/**
 * Simple logger service implementation
 * Only outputs console.log in development mode for debugging purposes
 * In production mode, all logging calls are silently ignored with zero overhead
 */
export class LoggerService {
    constructor() {
        Object.defineProperty(this, "isDevelopment", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // Check if we're in development mode
        this.isDevelopment = !import.meta.env.PROD;
    }
    static getInstance() {
        if (!LoggerService.instance) {
            LoggerService.instance = new LoggerService();
        }
        return LoggerService.instance;
    }
    /**
     * Debug logging - only shows in development mode
     * Simple console.log output for debugging purposes
     * In production, this becomes a no-op for maximum performance
     */
    debug(...args) {
        if (this.isDevelopment) {
            console.log(...args);
        }
    }
    warn(...args) {
        if (this.isDevelopment) {
            console.warn(...args);
        }
    }
    error(...args) {
        if (this.isDevelopment) {
            console.error(...args);
        }
    }
}
// Export a singleton instance
export const logger = LoggerService.getInstance();
